<template>
  <v-row v-if="clients.length <= 0">
    <v-col>
      <div class="text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </v-col>
  </v-row>
  <v-row v-else>
    <v-col v-for="client in clients" :key="client.id">
      <v-card :class="(session && session.name == client.name || !session ? 'active' : 'inactive')"
        :style="`border-color: ${client.color}; border-width: 3px;`">
        <!-- Profile picture -->
        <v-card-title v-if="client.logo" class="justify-center">
          <v-img :src="`${apiUrl}/storage/${client.logo}`" aspect-ratio="3" contain class="lighten-2">
            <template v-slot:placeholder>
              <v-row class="fill-width ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="primary lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-title>
        <!-- Client name -->
        <v-card-title v-else>
          <v-row justify="center" class="mt-2">
            <h3 class="text-center text-h6 font-weight-medium">{{ client.name }}</h3>
          </v-row>
        </v-card-title>
        <v-card-actions>
          <v-btn fab small :color="client.color" @click="selectClient(client)">
            <v-icon color="white" light>
              fal fa-hand-pointer
            </v-icon>
          </v-btn>
          <action-crud :item="{client}" activity="update" @callback="logoCallback"></action-crud>
          <action-crud :item="{client}" activity="delete"></action-crud>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
  .active {
    border-left-width: 10px !important;
    border-left-style: solid;
    border-right-style: solid;
    border-top-style: solid;
    border-bottom-style: solid;
  }
</style>

<script>
  import {
    mapState
  } from 'vuex'
  import actionCrud from '@/components/actions/actCRUD'

  export default {
    props: [
      "logoClient",
      "clientName",
    ],
    components: {
      actionCrud
    },
    computed: {
      ...mapState('clients', ['clients']),
      ...mapState('session', ['session']),
    },
    created() {
      this.$store.dispatch('clients/fetch')
    },
    methods: {
      selectClient(client) {
        if (this.session) {
          if (this.session.name !== client.name) {
            this.$store.dispatch('session/update', client)
            this.$store.dispatch('alfakodos/fetch')
            this.$store.dispatch('targettimes/fetch')
            this.$store.dispatch('jumblewords/fetch')
            this.$toastr.s('You\'re now working with ' + client.name)
          } else {
            this.$toastr.w('You\'re already working with ' + client.name)
          }
        } else {
          this.$store.dispatch('session/update', client)
          this.$toastr.s('Set new session. ' + client.name + ' has been selected.')
        }
      },
      logoCallback(url, clientId) {
        this.logoUrl = url
        this.clientId = clientId
      }
    },
    data() {
      return {
        apiUrl: process.env.VUE_APP_API_URL,
        dialog: false,
        isUpdating: false,
        isRemoving: false,
        client: {
          name: null
        },
        expand: false,
        logoUrl: "",
        clientId: ""
      }
    }
  }
</script>

<style>

</style>